import React, { useState, useEffect } from 'react';
import { C, R, SHADOW, fmt } from '../tokens.js';
import { Card, Btn, BkHdr, Badge, Chip, Stepper, Divider, SHead, ImgOrEmoji, StarPicker, RatingBars, ReviewCard } from '../components/ui.jsx';
import { D } from '../mock-data.js';
import { CrossSellRow } from './CheckoutScreens.jsx';
import { getRecommendations } from '../api/recommendations.js';
import { createSubscription } from '../api/subscriptions.js';
import { useApi, useAction } from '../lib/hooks.js';
import { humanizeError } from '../lib/errors.js';
import { initialChargePaise, paymentCycleLabel, paymentCycleDescription } from '../lib/payment.js';

/* ── Branch Page ─────────────────────────────────────────────── */
export const BranchScreen = ({branch:b,btype,navigate,goBack,cart,setCart,addToRoutineBasket,routineBasket}) => {
  const [selCat,setSelCat]=useState('All');
  const isSalon=btype==='salons';
  const catF=isSalon?null:[...new Set(b.products?.map(p=>p.cat)||[])];
  const items=isSalon?b.services:(selCat==='All'?b.products:b.products?.filter(p=>p.cat===selCat));

  const inBasket = (productId, variantLabel) =>
    routineBasket?.items?.some((it) => it.productId === productId && it.variantLabel === variantLabel);

  const addToCart=(product,variant)=>{
    if(cart.branchId&&cart.branchId!==b.id&&cart.items.length>0){
      if(!window.confirm(`Your cart has items from ${cart.branchName}. Start a new cart from ${b.name}?`))return;
      setCart({branchId:b.id,branchName:b.name,items:[]});
    }
    setCart(c=>{
      const ex=c.items.findIndex(i=>i.productId===product.id&&i.variant===variant.l);
      if(ex>=0)return{...c,items:c.items.map((i,ix)=>ix===ex?{...i,qty:i.qty+1}:i)};
      return{branchId:b.id,branchName:b.name,items:[...c.items,{productId:product.id,name:product.name,variant:variant.l,priceP:variant.p,qty:1}]};
    });
  };

  const cartCount=cart.items.reduce((a,i)=>a+i.qty,0);
  return (
    <div className="fade-in" style={{flex:1,display:'flex',flexDirection:'column'}}>
      <BkHdr title={b.name} onBack={goBack} right={
        !isSalon&&(
          <button onClick={()=>navigate('cart')} style={{width:40,height:40,borderRadius:R.lg,background:C.white,border:`1px solid ${C.border}`,display:'flex',alignItems:'center',justifyContent:'center',cursor:'pointer',position:'relative',boxShadow:'0 1px 2px rgba(28,25,23,.04)'}}>
            <svg width="18" height="18" viewBox="0 0 20 20" fill="none"><path d="M2 2h2l1.4 7M6 13h10l2-7H5.4" stroke={C.text} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/><circle cx="8" cy="17" r="1.5" fill={C.text}/><circle cx="14" cy="17" r="1.5" fill={C.text}/></svg>
            {cartCount>0&&cart.branchId===b.id&&<div style={{position:'absolute',top:-4,right:-4,minWidth:16,height:16,padding:'0 4px',borderRadius:8,background:C.primary,color:C.white,fontSize:9,fontWeight:800,display:'flex',alignItems:'center',justifyContent:'center',border:`2px solid ${C.bg}`,fontVariantNumeric:'tabular-nums'}}>{cartCount}</div>}
          </button>
        )
      }/>
      <div style={{padding:'18px 16px 18px',background:'linear-gradient(160deg,#f1fbfd 0%,#d4f1f7 100%)'}}>
        <div style={{display:'flex',gap:14,alignItems:'center'}}>
          <ImgOrEmoji src={D.storeImages[b.id]} fallback={b.em} size={64} radius={R.xl} bg={b.bg} fontSize={32}/>
          <div style={{flex:1,minWidth:0}}>
            <div style={{display:'flex',gap:6,flexWrap:'wrap',marginBottom:8}}>
              {b.certified&&<Badge bg="#dcfce7" color="#15803d" sm>✓ FSSAI Certified</Badge>}
              <Badge bg="rgba(245,245,244,.85)" color={C.textMed} sm>⏰ {b.hours}</Badge>
              <Badge bg="#f0fdf4" color="#15803d" sm>📍 {b.dist} km</Badge>
            </div>
            <div style={{display:'flex',alignItems:'center',gap:5}}>
              <svg width="13" height="13" viewBox="0 0 12 12" fill="#d97706"><polygon points="6,1 7.5,4.5 11.5,5 8.5,7.5 9.5,11.5 6,9.5 2.5,11.5 3.5,7.5 0.5,5 4.5,4.5"/></svg>
              <span style={{fontSize:13,fontWeight:800,color:C.text,fontVariantNumeric:'tabular-nums'}}>{b.rating}</span>
              <span style={{fontSize:11,color:C.textMed,fontVariantNumeric:'tabular-nums'}}>({b.reviews} reviews)</span>
            </div>
          </div>
        </div>
      </div>
      {!isSalon&&catF&&catF.length>0&&(
        <div style={{display:'flex',gap:8,overflowX:'auto',padding:'12px 16px 0'}}>
          {['All',...catF].map(c=><Chip key={c} active={selCat===c} onClick={()=>setSelCat(c)}>{c}</Chip>)}
        </div>
      )}
      <div style={{flex:1,overflowY:'auto',padding:'14px 16px 20px',display:'flex',flexDirection:'column',gap:10}}>
        {(items||[]).map(item=>(
          <Card key={item.id}>
            {isSalon?(
              <div>
                <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start',marginBottom:8,gap:12}}>
                  <div style={{minWidth:0,flex:1}}>
                    <p style={{fontSize:15,fontWeight:800,color:C.text,letterSpacing:-.1,lineHeight:1.3}}>{item.name}</p>
                    <p style={{fontSize:12,color:C.textMed,marginTop:3}}>⏱ {item.duration} min</p>
                  </div>
                  <div style={{textAlign:'right',flexShrink:0}}>
                    <p style={{fontSize:16,fontWeight:800,color:C.primary,fontVariantNumeric:'tabular-nums',letterSpacing:-.2}}>{fmt(item.priceP)}</p>
                    {item.advanceP>0&&<p style={{fontSize:11,color:C.textMed,marginTop:2,fontVariantNumeric:'tabular-nums'}}>Advance · {fmt(item.advanceP)}</p>}
                  </div>
                </div>
                {item.refundBy&&<p style={{fontSize:11,color:C.warning,marginBottom:10,lineHeight:1.4,fontWeight:600}}>⚠️ Free cancel until {item.refundBy} before slot</p>}
                <Btn sm full onClick={()=>navigate('booking-service',{service:item,branch:b})}>Book this service</Btn>
              </div>
            ):(
              <div>
                <div style={{display:'flex',gap:12,alignItems:'flex-start',marginBottom:12}}>
                  <ImgOrEmoji src={D.productImages[item.id]} fallback={item.em} size={48} radius={R.lg} bg="#e6f7fb"/>
                  <div style={{flex:1,minWidth:0}}>
                    <button onClick={()=>navigate('product',{product:item,branch:b})} style={{background:'none',border:'none',padding:0,cursor:'pointer',textAlign:'left',width:'100%'}}>
                      <p style={{fontSize:15,fontWeight:800,color:C.text,letterSpacing:-.1,lineHeight:1.3,whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'}}>{item.name}</p>
                    </button>
                    <p style={{fontSize:11,color:C.textMed,marginTop:3,lineHeight:1.4,display:'-webkit-box',WebkitLineClamp:2,WebkitBoxOrient:'vertical',overflow:'hidden'}}>{item.desc}</p>
                  </div>
                </div>
                {item.subscribable !== false && (
                  <>
                    <button
                      onClick={()=>{ if(!inBasket(item.id,item.variants[0].l)) addToRoutineBasket?.(item,b,{variantLabel:item.variants[0].l}); }}
                      disabled={inBasket(item.id,item.variants[0].l)}
                      style={{width:'100%',display:'flex',alignItems:'center',justifyContent:'center',gap:6,padding:'10px 12px',borderRadius:R.lg,border:'none',background:inBasket(item.id,item.variants[0].l)?C.successBg:C.primary,color:inBasket(item.id,item.variants[0].l)?C.success:C.white,fontSize:13,fontWeight:800,cursor:inBasket(item.id,item.variants[0].l)?'default':'pointer',marginBottom:6,letterSpacing:.1,boxShadow:inBasket(item.id,item.variants[0].l)?'none':'0 1px 2px rgba(12,192,223,.18), 0 4px 10px rgba(12,192,223,.18)',minHeight:42}}>
                      {inBasket(item.id,item.variants[0].l) ? '✓ In your routine' : `+ Add to routine · from ${fmt(item.variants[0].p)} / delivery`}
                    </button>
                    <div style={{display:'flex',justifyContent:'center',marginBottom:8}}>
                      <button onClick={()=>navigate('product',{product:item,branch:b,openSubscribeOnMount:true,variantLabel:item.variants[0].l})} style={{background:'none',border:'none',color:C.primary,fontSize:11,fontWeight:700,cursor:'pointer',padding:'4px 8px'}}>
                        Subscribe now →
                      </button>
                    </div>
                  </>
                )}
                {item.allowOneOff !== false ? (
                  <div style={{display:'flex',alignItems:'center',gap:8,flexWrap:'wrap'}}>
                    <span style={{fontSize:10,fontWeight:800,color:C.textMed,letterSpacing:.5,marginRight:2}}>{item.subscribable !== false ? 'OR BUY ONCE' : 'BUY ONCE'}</span>
                    {item.variants.map(v=>(
                      <div key={v.l} style={{display:'flex',gap:6,alignItems:'center',padding:'5px 6px 5px 10px',background:C.bg,borderRadius:R.sm,border:`1px solid ${C.border}`}}>
                        <span style={{fontSize:11,fontWeight:700,color:C.textMed}}>{v.l}</span>
                        <span style={{fontSize:12,fontWeight:700,color:C.text,fontVariantNumeric:'tabular-nums'}}>{fmt(v.p)}</span>
                        <button onClick={()=>addToCart(item,v)} aria-label={`Add ${item.name} ${v.l} once`} style={{width:24,height:24,borderRadius:6,border:`1px solid ${C.border}`,background:C.white,color:C.primary,fontSize:14,fontWeight:800,cursor:'pointer',display:'flex',alignItems:'center',justifyContent:'center',lineHeight:1}}>+</button>
                      </div>
                    ))}
                  </div>
                ) : (
                  <p style={{fontSize:10,fontWeight:700,color:C.textMed,letterSpacing:.3,marginTop:2}}>🔒 Subscription only · this supplier doesn't sell one-off</p>
                )}
              </div>
            )}
          </Card>
        ))}
      </div>
      {!isSalon&&cart.branchId===b.id&&cartCount>0&&(
        <div style={{padding:'12px 16px 16px',background:C.white,borderTop:`1px solid ${C.border}`,boxShadow:SHADOW.bottomBar}}>
          <Btn full onClick={()=>navigate('cart')}>View cart · {cartCount} item{cartCount>1?'s':''}</Btn>
        </div>
      )}
    </div>
  );
};

/* ── Write Review Screen ─────────────────────────────────────── */
export const WriteReviewScreen = ({branchName,goBack,onSubmit}) => {
  const [rating,setRating]=useState(0);
  const [text,setText]=useState('');
  const [productTag,setProductTag]=useState('');
  const [submitted,setSubmitted]=useState(false);
  const labels=['','Terrible','Poor','Okay','Good','Excellent!'];
  const submit=()=>{if(!rating||!text.trim())return;onSubmit({rating,text,productTag});setSubmitted(true);};
  if(submitted) return (
    <div className="fade-in" style={{flex:1,display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',padding:32,background:C.bg,textAlign:'center'}}>
      <div className="scale-in" style={{fontSize:72,marginBottom:20}}>🎉</div>
      <h2 style={{fontSize:22,fontWeight:800,color:C.text,marginBottom:8}}>Thanks for your review!</h2>
      <p style={{fontSize:14,color:C.textMed,marginBottom:28}}>Your feedback helps the community choose better.</p>
      <Btn full onClick={goBack}>Back to product</Btn>
    </div>
  );
  return (
    <div className="fade-in" style={{flex:1,display:'flex',flexDirection:'column'}}>
      <BkHdr title={`Rate ${branchName}`} onBack={goBack}/>
      <div style={{flex:1,overflowY:'auto',padding:'24px 20px',display:'flex',flexDirection:'column',gap:20}}>
        <div style={{padding:'24px 16px',background:'linear-gradient(135deg,#f1fbfd,#d4f1f7)',borderRadius:20,display:'flex',flexDirection:'column',alignItems:'center',gap:10}}>
          <p style={{fontSize:14,color:C.textMed,fontWeight:600}}>Tap to rate your experience</p>
          <StarPicker value={rating} onChange={setRating}/>
          <p style={{fontSize:16,fontWeight:800,color:rating?C.primary:C.textMed,minHeight:24}}>{rating?labels[rating]:'—'}</p>
        </div>
        <div>
          <p style={{fontSize:13,fontWeight:700,color:C.text,marginBottom:8}}>What did you buy / use? <span style={{color:C.textMed,fontWeight:400}}>(optional)</span></p>
          <input value={productTag} onChange={e=>setProductTag(e.target.value)} placeholder="e.g. Full Cream Milk, Haircut…"
            style={{width:'100%',padding:'12px 14px',borderRadius:14,border:`1.5px solid ${productTag?C.primary:C.border}`,fontSize:13,color:C.text,background:C.white,outline:'none',transition:'border .2s'}}/>
        </div>
        <div>
          <p style={{fontSize:13,fontWeight:700,color:C.text,marginBottom:8}}>Your review <span style={{color:C.error}}>*</span></p>
          <textarea value={text} onChange={e=>setText(e.target.value.slice(0,300))} rows={6}
            placeholder="Tell others about quality, freshness, on-time delivery, staff behaviour…"
            style={{width:'100%',padding:'13px 14px',borderRadius:14,border:`1.5px solid ${text?C.primary:C.border}`,resize:'none',fontSize:13,color:C.text,background:C.white,outline:'none',transition:'border .2s',lineHeight:1.6}}/>
          <p style={{fontSize:11,color:text.length>=280?C.error:C.textMed,textAlign:'right',marginTop:4}}>{text.length}/300</p>
        </div>
        <div style={{padding:'12px 14px',background:'#f0fdf4',borderRadius:12,border:'1px solid #bbf7d0'}}>
          <p style={{fontSize:12,fontWeight:700,color:'#15803d',marginBottom:4}}>💡 Helpful review tips</p>
          <p style={{fontSize:12,color:'#166534',lineHeight:1.6}}>Mention product quality, freshness, delivery timing, and whether you'd order again.</p>
        </div>
        <Btn full disabled={!rating||!text.trim()} onClick={submit}>Submit review</Btn>
        <div style={{height:16}}/>
      </div>
    </div>
  );
};

/* ── Product Detail Screen ───────────────────────────────────── */
export const ProductDetailScreen = ({product:p,branch:b,navigate,goBack,cart,setCart,addresses=[],setSubscriptions,openSubscribeOnMount=false,initialVariantLabel,initialCadence,addToRoutineBasket,routineBasket}) => {
  const initialV = initialVariantLabel ? Math.max(0, p.variants.findIndex(v=>v.l===initialVariantLabel)) : 0;
  const allowedCadences = Array.isArray(p.cadences) && p.cadences.length > 0 ? p.cadences : ['Daily','Alt-day','Weekly','Custom'];
  const subscribable = p.subscribable !== false;
  const allowOneOff = p.allowOneOff !== false;
  const [selV,setSelV]=useState(initialV);
  const [qty,setQty]=useState(1);
  const [showSub,setShowSub]=useState(openSubscribeOnMount);
  const [activeTab,setActiveTab]=useState('details');
  const [cadence,setCadence]=useState(initialCadence && allowedCadences.includes(initialCadence) ? initialCadence : allowedCadences[0]);
  const [customDays,setCustomDays]=useState({Mon:true,Tue:true,Wed:true,Thu:false,Fri:true,Sat:false,Sun:false});
  const [delWindow,setDelWindow]=useState('6–8 AM');
  const [subQty,setSubQty]=useState(1);
  const [subDone,setSubDone]=useState(false);
  const [selAddr,setSelAddr]=useState(addresses.find(a=>a.isDefault)||addresses[0]||null);
  const [payment,setPayment]=useState('upi');
  const [userReviews,setUserReviews]=useState([]);
  const [expandNutrition,setExpandNutrition]=useState(false);

  // Auto-open subscribe modal once on mount when navigated with the flag.
  // (Re-firing on prop change would surprise the user inside the modal.)
  useEffect(() => { if (openSubscribeOnMount) setShowSub(true); /* eslint-disable-next-line react-hooks/exhaustive-deps */ }, []);

  const v=p.variants[selV];
  const meta=D.productMeta[p.id]||{};
  const branchReviews=[...(D.branchReviews[b.id]||[]),...userReviews];
  const avgRating=branchReviews.length?Math.round(branchReviews.reduce((a,r)=>a+r.rating,0)/branchReviews.length*10)/10:b.rating;
  const activeDays=Object.entries(customDays).filter(([,v])=>v).map(([k])=>k).join(', ');
  const monthlyEst=()=>{const mult=cadence==='Daily'?30:cadence==='Alt-day'?15:cadence==='Weekly'?4:Object.values(customDays).filter(Boolean).length*4;return fmt(v.p*subQty*mult);};
  const supplierCycle = b.paymentCycle || 'per_delivery';
  const initialCharge = initialChargePaise(supplierCycle, v.p, subQty, cadence, cadence === 'Custom' ? customDays : null);

  // Same-store cross-sell shown inside the Subscribe modal. Tapping "View"
  // closes the modal and opens that product's detail — purely discovery.
  const subRecos = useApi(
    () => getRecommendations({context:'subscription_modal', branchId:b.id, items:[{productId:p.id}], limit:3}),
    [b.id, p.id],
  );
  const openRecommendation = (rec) => {
    const recProduct = b.products?.find((x) => x.id === rec.id);
    if (!recProduct) return;
    setShowSub(false);
    setSubDone(false);
    navigate('product',{product:recProduct,branch:b});
  };

  // Real subscribe action — replaces the old setSubDone(true) cosmetic flow.
  const subscribeAction = useAction(async () => {
    const sub = await createSubscription({
      branchId: b.id,
      branchName: b.name,
      productId: p.id,
      productName: p.name,
      productEm: p.em,
      variantLabel: v.l,
      qty: subQty,
      cadence,
      customDays: cadence === 'Custom' ? customDays : undefined,
      weeklyDay: cadence === 'Weekly' ? 'Mon' : undefined,
      deliveryWindow: delWindow,
      addressId: selAddr?.id,
      paymentMode: payment,
      pricePaise: v.p,
    });
    // Reflect in App-level subscriptions state so Home + Subs tab show it.
    if (typeof setSubscriptions === 'function') {
      setSubscriptions((prev) => [{ ...sub, skippedDates: sub.skippedDates || [] }, ...prev]);
    }
    setSubDone(true);
    return sub;
  });

  const addCart=()=>{
    if(cart.branchId&&cart.branchId!==b.id&&cart.items.length>0){if(!window.confirm(`Start new cart from ${b.name}?`))return;setCart({branchId:b.id,branchName:b.name,items:[]});}
    setCart(c=>{const ex=c.items.findIndex(i=>i.productId===p.id&&i.variant===v.l);
      if(ex>=0)return{...c,items:c.items.map((i,ix)=>ix===ex?{...i,qty:i.qty+qty}:i)};
      return{branchId:b.id,branchName:b.name,items:[...c.items,{productId:p.id,name:p.name,variant:v.l,priceP:v.p,qty}]};});
    navigate('cart');
  };

  const handleReviewSubmit=(r)=>{
    setUserReviews(prev=>[{id:`u${Date.now()}`,name:'You',avatar:'YO',rating:r.rating,date:'Just now',text:r.text,productTag:r.productTag,verified:true,helpful:0},...prev]);
  };

  return (
    <div className="fade-in" style={{flex:1,display:'flex',flexDirection:'column',position:'relative'}}>
      <BkHdr title={p.name} onBack={goBack}/>
      <div style={{display:'flex',background:'#f5f5f4',margin:'10px 16px 0',borderRadius:R.lg,padding:4,gap:4,flexShrink:0}}>
        {['details','reviews'].map(t=>{const on=activeTab===t;return (
          <button key={t} onClick={()=>setActiveTab(t)} style={{flex:1,padding:'9px',borderRadius:R.md,border:'none',background:on?C.white:'transparent',color:on?C.primary:C.textMed,fontSize:13,fontWeight:800,cursor:'pointer',boxShadow:on?'0 1px 3px rgba(28,25,23,.08)':'none',transition:'all .18s',letterSpacing:.1}}>
            {t==='details'?'Details':`Reviews (${branchReviews.length})`}
          </button>
        );})}
      </div>
      <div style={{flex:1,overflowY:'auto',padding:'14px 16px 100px',display:'flex',flexDirection:'column',gap:16}}>
        {activeTab==='details'&&<>
          <div style={{height:172,borderRadius:R.xxl,background:'linear-gradient(135deg,#e6f7fb,#d4f1f7)',display:'flex',alignItems:'center',justifyContent:'center',position:'relative',overflow:'hidden'}}>
            <ImgOrEmoji src={D.productImages[p.id]} fallback={p.em} size={108} radius={R.xxl} bg="transparent" fontSize={88}/>
            <div style={{position:'absolute',top:12,left:12}}><Badge bg="rgba(255,241,235,.92)" color={C.primary} sm>{p.cat}</Badge></div>
            {meta.bestFor&&<div style={{position:'absolute',bottom:12,right:12,background:'rgba(255,255,255,.88)',padding:'5px 10px',borderRadius:R.pill,fontSize:11,fontWeight:700,color:C.textMed}}>Best for · {meta.bestFor}</div>}
          </div>
          <div>
            <h2 style={{fontSize:22,fontWeight:800,color:C.text,marginBottom:6,letterSpacing:-.4,lineHeight:1.2}}>{p.name}</h2>
            <div style={{display:'flex',alignItems:'center',gap:8,flexWrap:'wrap'}}>
              <div style={{display:'flex',gap:1}}>{[1,2,3,4,5].map(n=><span key={n} style={{fontSize:13,color:n<=Math.round(avgRating)?'#d97706':'#e5e7eb'}}>★</span>)}</div>
              <span style={{fontSize:13,fontWeight:800,color:C.text,fontVariantNumeric:'tabular-nums'}}>{avgRating}</span>
              <span style={{fontSize:12,color:C.textMed,fontVariantNumeric:'tabular-nums'}}>({branchReviews.length} reviews)</span>
              <button onClick={()=>setActiveTab('reviews')} style={{background:'none',border:'none',color:C.primary,fontSize:12,fontWeight:700,cursor:'pointer',padding:'4px 6px',marginLeft:'auto'}}>See all →</button>
            </div>
          </div>
          {meta.highlights&&(
            <div>
              <p style={{fontSize:11,fontWeight:800,color:C.textMed,marginBottom:8,letterSpacing:.6}}>HIGHLIGHTS</p>
              <div style={{display:'flex',gap:6,flexWrap:'wrap'}}>
                {meta.highlights.map((h,i)=><span key={i} style={{display:'inline-flex',alignItems:'center',gap:5,padding:'6px 10px',background:'#f0fdf4',border:'1px solid #bbf7d0',borderRadius:R.pill,fontSize:11,fontWeight:700,color:'#15803d'}}>✓ {h}</span>)}
              </div>
            </div>
          )}
          {meta.about&&(
            <div style={{padding:'14px 16px',background:C.white,borderRadius:R.xl,border:`1px solid ${C.border}`,boxShadow:SHADOW.card}}>
              <p style={{fontSize:13,fontWeight:800,color:C.text,marginBottom:6,letterSpacing:-.1}}>About this product</p>
              <p style={{fontSize:13,color:C.textMed,lineHeight:1.6}}>{meta.about}</p>
            </div>
          )}
          <button onClick={()=>{ const full=D.branches.grocery.find(x=>x.id===b.id)||D.branches.salons.find(x=>x.id===b.id)||b; navigate('branch',{branch:full,btype:D.branches.salons.some(s=>s.id===b.id)?'salons':'grocery'}); }} style={{width:'100%',padding:'12px 14px',background:'#fff8f4',borderRadius:R.xl,border:`1px solid ${C.primaryLight}`,display:'flex',gap:12,alignItems:'center',cursor:'pointer',textAlign:'left'}}>
            <div style={{width:44,height:44,borderRadius:R.lg,background:b.bg||'#e6f7fb',display:'flex',alignItems:'center',justifyContent:'center',fontSize:22,flexShrink:0,lineHeight:1}}>{b.em||'🏬'}</div>
            <div style={{flex:1,minWidth:0}}>
              <p style={{fontSize:13,fontWeight:800,color:C.text,letterSpacing:-.1,whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'}}>{b.name}</p>
              <p style={{fontSize:11,color:C.textMed,marginTop:2,lineHeight:1.4,whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'}}>{b.type||'Store'}{b.dist?` · ${b.dist} km`:''}{b.hours?` · ${b.hours}`:''}</p>
              <p style={{fontSize:11,color:C.primary,marginTop:3,fontWeight:700,letterSpacing:.1}}>Visit store →</p>
            </div>
            <div style={{display:'flex',flexDirection:'column',alignItems:'flex-end',gap:4,flexShrink:0}}>
              <div style={{display:'flex',gap:3,alignItems:'center'}}>
                <span style={{fontSize:13,color:'#d97706'}}>★</span>
                <span style={{fontSize:13,fontWeight:800,color:C.text,fontVariantNumeric:'tabular-nums'}}>{b.rating}</span>
              </div>
              {b.certified&&<Badge bg="#dcfce7" color="#15803d" sm>Certified</Badge>}
            </div>
          </button>
          <div>
            <p style={{fontSize:11,fontWeight:800,color:C.textMed,marginBottom:8,letterSpacing:.6}}>SELECT SIZE</p>
            <div style={{display:'flex',gap:8,flexWrap:'wrap'}}>
              {p.variants.map((variant,i)=>{const on=selV===i;return (
                <button key={i} onClick={()=>setSelV(i)} style={{padding:'10px 16px',borderRadius:R.lg,border:`1.5px solid ${on?C.primary:C.border}`,background:on?'#e6f7fb':C.white,cursor:'pointer',display:'flex',flexDirection:'column',alignItems:'center',gap:2,transition:'all .15s',minWidth:80,minHeight:60}}>
                  <span style={{fontSize:11,fontWeight:700,color:on?C.primary:C.textMed,letterSpacing:.2}}>{variant.l}</span>
                  <span style={{fontSize:15,fontWeight:800,color:on?C.primary:C.text,fontVariantNumeric:'tabular-nums'}}>{fmt(variant.p)}</span>
                </button>
              );})}
            </div>
          </div>
          <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',padding:'4px 2px'}}>
            <div>
              <p style={{fontSize:13,fontWeight:800,color:C.text,letterSpacing:-.1}}>Quantity</p>
              <p style={{fontSize:11,color:C.textMed,marginTop:2}}>per order</p>
            </div>
            <Stepper value={qty} onChange={setQty}/>
          </div>
          <div style={{padding:'12px 14px',background:C.bg,borderRadius:R.lg,border:`1px solid ${C.border}`}}>
            <div style={{display:'flex',justifyContent:'space-between',alignItems:'baseline',marginBottom:4}}>
              <span style={{fontSize:13,color:C.textMed}}>Item total</span>
              <span style={{fontSize:17,fontWeight:800,color:C.primary,fontVariantNumeric:'tabular-nums',letterSpacing:-.2}}>{fmt(v.p*qty)}</span>
            </div>
            <p style={{fontSize:11,color:C.textMed,lineHeight:1.4}}>Delivery + taxes added at checkout</p>
          </div>
          {meta.nutrition&&<div style={{borderRadius:16,border:`1px solid ${C.border}`,overflow:'hidden'}}>
            <button onClick={()=>setExpandNutrition(x=>!x)} style={{width:'100%',padding:'13px 16px',background:C.white,border:'none',display:'flex',justifyContent:'space-between',alignItems:'center',cursor:'pointer'}}>
              <span style={{fontSize:13,fontWeight:700,color:C.text}}>Nutritional info <span style={{fontWeight:400,color:C.textMed,fontSize:12}}>(per serving)</span></span>
              <span style={{fontSize:16,color:C.textMed,transform:expandNutrition?'rotate(180deg)':'none',transition:'transform .2s'}}>⌄</span>
            </button>
            {expandNutrition&&<div style={{background:C.bg,padding:'12px 16px'}}>
              {meta.nutrition.map((n,i)=>(
                <div key={i} style={{display:'flex',justifyContent:'space-between',padding:'8px 0',borderBottom:i<meta.nutrition.length-1?`1px solid ${C.border}`:'none'}}>
                  <span style={{fontSize:13,color:C.textMed}}>{n.l}</span>
                  <span style={{fontSize:13,fontWeight:700,color:C.text}}>{n.v}</span>
                </div>
              ))}
            </div>}
          </div>}
        </>}
        {activeTab==='reviews'&&<>
          <div style={{padding:'18px',background:C.white,borderRadius:20,border:`1px solid ${C.border}`,display:'flex',gap:20,alignItems:'center'}}>
            <div style={{textAlign:'center',flexShrink:0}}>
              <p style={{fontSize:42,fontWeight:800,color:C.text,lineHeight:1}}>{avgRating}</p>
              <div style={{display:'flex',gap:2,justifyContent:'center',margin:'4px 0'}}>{[1,2,3,4,5].map(n=><span key={n} style={{fontSize:14,color:n<=Math.round(avgRating)?'#d97706':'#e5e7eb'}}>★</span>)}</div>
              <p style={{fontSize:11,color:C.textMed}}>{branchReviews.length} reviews</p>
            </div>
            <div style={{flex:1}}><RatingBars reviews={branchReviews}/></div>
          </div>
          <div style={{padding:'12px 14px',background:'#fff8f4',borderRadius:14,border:`1px solid ${C.primaryLight}`,display:'flex',gap:12,alignItems:'center'}}>
            <div style={{width:40,height:40,borderRadius:11,background:b.bg,display:'flex',alignItems:'center',justifyContent:'center',fontSize:20,flexShrink:0}}>{b.em}</div>
            <div style={{flex:1}}><p style={{fontSize:13,fontWeight:700,color:C.text}}>{b.name}</p><p style={{fontSize:11,color:C.textMed}}>{b.reviews} total ratings · {b.dist} km</p></div>
            {b.certified&&<Badge bg="#dcfce7" color="#15803d" sm>Certified</Badge>}
          </div>
          <button onClick={()=>navigate('write-review',{branchName:b.name,productName:p.name})} style={{padding:'13px 16px',borderRadius:14,border:`1.5px solid ${C.primary}`,background:'#e6f7fb',color:C.primary,fontSize:14,fontWeight:700,cursor:'pointer',display:'flex',alignItems:'center',justifyContent:'center',gap:8}}>
            ✏️ Write a review
          </button>
          <div>
            {branchReviews.length===0&&<div style={{textAlign:'center',padding:'32px 20px'}}><p style={{fontSize:48,marginBottom:12}}>💬</p><p style={{fontSize:14,fontWeight:700,color:C.text}}>No reviews yet</p></div>}
            {branchReviews.map(r=><ReviewCard key={r.id} r={r} onHelpful={()=>{}}/>)}
          </div>
        </>}
      </div>
      <div style={{position:'absolute',bottom:0,left:0,right:0,padding:'12px 16px 16px',background:C.white,borderTop:`1px solid ${C.border}`,boxShadow:SHADOW.bottomBar}}>
        {subscribable ? (
          <>
            {(() => {
              const inB = routineBasket?.items?.some((it) => it.productId === p.id && it.variantLabel === v.l);
              return (
                <Btn full disabled={inB} onClick={() => { if (!inB) addToRoutineBasket?.(p, b, { variantLabel: v.l, qty }); }}>
                  {inB ? '✓ In your routine' : `+ Add to routine · from ${fmt(v.p)} / delivery`}
                </Btn>
              );
            })()}
            <div style={{display:'flex',alignItems:'center',justifyContent:'center',gap:14,marginTop:10,flexWrap:'wrap'}}>
              <button onClick={()=>setShowSub(true)} style={{background:'none',border:'none',color:C.primary,fontSize:12,fontWeight:700,cursor:'pointer',padding:'4px 6px',letterSpacing:.1}}>Subscribe now →</button>
              {allowOneOff && (
                <>
                  <span style={{width:3,height:3,borderRadius:2,background:C.textLight}}/>
                  <button onClick={addCart} style={{background:'none',border:'none',color:C.textMed,fontSize:12,fontWeight:700,cursor:'pointer',padding:'4px 6px',letterSpacing:.1}}>buy once · <span style={{color:C.text,fontVariantNumeric:'tabular-nums'}}>{fmt(v.p*qty)}</span></button>
                </>
              )}
              <span style={{width:3,height:3,borderRadius:2,background:C.textLight}}/>
              <button onClick={()=>navigate('write-review',{branchName:b.name,productName:p.name})} style={{background:'none',border:'none',color:C.textMed,fontSize:12,fontWeight:700,cursor:'pointer',padding:'4px 6px',letterSpacing:.1}}>✏️ Review</button>
            </div>
            {!allowOneOff && (
              <p style={{fontSize:10,color:C.textMed,textAlign:'center',marginTop:6,fontWeight:600,letterSpacing:.1}}>🔒 This supplier offers this product on subscription only</p>
            )}
          </>
        ) : allowOneOff ? (
          <>
            <Btn full onClick={addCart}>Add to cart · {fmt(v.p*qty)}</Btn>
            <div style={{display:'flex',alignItems:'center',justifyContent:'center',gap:14,marginTop:10}}>
              <p style={{fontSize:11,color:C.textMed,fontWeight:600,letterSpacing:.1}}>One-off product · not available as a subscription</p>
            </div>
          </>
        ) : (
          <div style={{padding:'12px 16px',textAlign:'center'}}>
            <p style={{fontSize:13,fontWeight:700,color:C.textMed}}>Not currently available</p>
          </div>
        )}
      </div>
      {/* Subscribe modal */}
      {showSub&&(
        <div style={{position:'absolute',inset:0,background:'rgba(0,0,0,.45)',display:'flex',alignItems:'flex-end',zIndex:20}} onClick={()=>{if(!subDone)setShowSub(false);}}>
          <div style={{background:C.white,borderRadius:'24px 24px 0 0',width:'100%',maxHeight:'88%',overflow:'hidden',display:'flex',flexDirection:'column'}} onClick={e=>e.stopPropagation()}>
            <div style={{display:'flex',justifyContent:'center',padding:'12px 0 0'}}><div style={{width:40,height:4,borderRadius:2,background:C.border}}/></div>
            {subDone?(
              <div style={{flex:1,display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',padding:32,textAlign:'center'}}>
                <div className="scale-in" style={{fontSize:64,marginBottom:16}}>✅</div>
                <h3 style={{fontSize:20,fontWeight:800,color:C.text,marginBottom:8}}>Subscription set up!</h3>
                <p style={{fontSize:14,color:C.textMed}}>Your {p.name} ({v.l}) will be delivered {cadence==='Custom'?`on ${activeDays}`:cadence.toLowerCase()} during {delWindow}.</p>
                <button onClick={()=>{setShowSub(false);setSubDone(false);}} style={{marginTop:20,background:'none',border:'none',color:C.primary,fontSize:14,fontWeight:700,cursor:'pointer'}}>Done</button>
              </div>
            ):(
              <div style={{flex:1,overflowY:'auto',padding:'16px 20px 24px',display:'flex',flexDirection:'column',gap:16}}>
                <div style={{display:'flex',justifyContent:'space-between',alignItems:'center'}}>
                  <p style={{fontSize:17,fontWeight:800,color:C.text}}>Subscribe to {p.name}</p>
                  <button onClick={()=>setShowSub(false)} style={{width:28,height:28,borderRadius:7,border:`1px solid ${C.border}`,background:C.white,cursor:'pointer',fontSize:16}}>×</button>
                </div>
                <p style={{fontSize:13,color:C.textMed}}>{b.name} · {v.l} · {fmt(v.p)}/delivery</p>
                <div>
                  <p style={{fontSize:13,fontWeight:700,color:C.text,marginBottom:8}}>Delivery cadence</p>
                  <div style={{display:'flex',gap:8,flexWrap:'wrap'}}>
                    {allowedCadences.map(c=><button key={c} onClick={()=>setCadence(c)} style={{padding:'8px 16px',borderRadius:10,border:`1.5px solid ${cadence===c?C.primary:C.border}`,background:cadence===c?'#e6f7fb':C.white,color:cadence===c?C.primary:C.textMed,fontSize:13,fontWeight:700,cursor:'pointer'}}>{c}</button>)}
                  </div>
                  {cadence==='Custom'&&<div style={{marginTop:10,display:'flex',gap:6,flexWrap:'wrap'}}>
                    {Object.keys(customDays).map(d=><button key={d} onClick={()=>setCustomDays(p=>({...p,[d]:!p[d]}))} style={{padding:'6px 12px',borderRadius:8,border:`1.5px solid ${customDays[d]?C.primary:C.border}`,background:customDays[d]?'#e6f7fb':C.white,color:customDays[d]?C.primary:C.textMed,fontSize:12,fontWeight:700,cursor:'pointer'}}>{d}</button>)}
                  </div>}
                </div>
                <div style={{display:'flex',alignItems:'center',justifyContent:'space-between'}}><p style={{fontSize:13,fontWeight:700,color:C.text}}>Qty per delivery</p><Stepper value={subQty} onChange={setSubQty}/></div>
                <div>
                  <p style={{fontSize:13,fontWeight:700,color:C.text,marginBottom:8}}>Delivery window</p>
                  <div style={{display:'flex',gap:8}}>
                    {['6–8 AM','8–10 AM','10 AM–12 PM'].map(w=><button key={w} onClick={()=>setDelWindow(w)} style={{flex:1,padding:'10px 6px',borderRadius:10,border:`1.5px solid ${delWindow===w?C.primary:C.border}`,background:delWindow===w?'#e6f7fb':C.white,color:delWindow===w?C.primary:C.textMed,fontSize:12,fontWeight:700,cursor:'pointer'}}>{w}</button>)}
                  </div>
                </div>
                {addresses.length>0&&(
                  <div>
                    <p style={{fontSize:13,fontWeight:700,color:C.text,marginBottom:8,letterSpacing:-.1}}>Deliver to</p>
                    {selAddr&&(
                      <div style={{padding:'12px 14px',background:C.bg,borderRadius:R.lg,border:`1px solid ${C.border}`}}>
                        <Badge bg="#e6f7fb" color={C.primary} sm>{selAddr.label}</Badge>
                        <p style={{fontSize:13,color:C.text,marginTop:6,lineHeight:1.5}}>{selAddr.full}</p>
                      </div>
                    )}
                    {addresses.length>1&&(
                      <div style={{display:'flex',gap:8,marginTop:10,overflowX:'auto',paddingBottom:2}}>
                        {addresses.map(a=>{const on=selAddr?.id===a.id;return (
                          <button key={a.id} onClick={()=>setSelAddr(a)} style={{flexShrink:0,padding:'8px 14px',borderRadius:R.md,border:`1.5px solid ${on?C.primary:C.border}`,background:on?'#e6f7fb':C.white,color:on?C.primary:C.textMed,fontSize:12,fontWeight:700,cursor:'pointer',minHeight:34}}>{a.label}{a.isDefault?' · default':''}</button>
                        );})}
                      </div>
                    )}
                  </div>
                )}
                <div>
                  <p style={{fontSize:13,fontWeight:700,color:C.text,marginBottom:8,letterSpacing:-.1}}>Payment per delivery</p>
                  {[{id:'upi',l:'UPI Autopay',sub:'Charged before each delivery'},{id:'cod',l:'Cash on delivery',sub:'Pay the rider each time'}].map((pm,i)=>{const on=payment===pm.id;return (
                    <div key={pm.id} onClick={()=>setPayment(pm.id)} style={{display:'flex',gap:12,alignItems:'center',padding:'12px 14px',borderRadius:R.lg,border:`1.5px solid ${on?C.primary:C.border}`,background:on?'#e6f7fb':C.white,marginBottom:i===0?8:0,cursor:'pointer',minHeight:54}}>
                      <div style={{width:20,height:20,borderRadius:10,border:`2px solid ${on?C.primary:'#d6d3d1'}`,display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0,background:C.white}}>{on&&<div style={{width:10,height:10,borderRadius:5,background:C.primary}}/>}</div>
                      <div style={{minWidth:0,flex:1}}>
                        <p style={{fontSize:13,fontWeight:700,color:C.text,lineHeight:1.3}}>{pm.l}</p>
                        <p style={{fontSize:11,color:C.textMed,marginTop:2,lineHeight:1.4}}>{pm.sub}</p>
                      </div>
                    </div>
                  );})}
                </div>
                <div style={{padding:'14px 16px',background:'#e6f7fb',borderRadius:R.lg,border:`1px solid ${C.primaryLight}`}}>
                  <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:6}}>
                    <span style={{fontSize:12,fontWeight:800,color:C.primary,letterSpacing:.3}}>💳 {paymentCycleLabel(supplierCycle).toUpperCase()}</span>
                    <span style={{fontSize:18,fontWeight:800,color:C.primary,fontVariantNumeric:'tabular-nums'}}>{fmt(initialCharge)}</span>
                  </div>
                  <p style={{fontSize:11,color:C.textMed,lineHeight:1.45,marginBottom:6}}>{paymentCycleDescription(supplierCycle)}</p>
                  <div style={{display:'flex',justifyContent:'space-between',paddingTop:6,borderTop:`1px solid ${C.primaryLight}`}}>
                    <span style={{fontSize:11,color:C.textLight}}>Est. monthly value</span>
                    <span style={{fontSize:11,color:C.textMed,fontWeight:600,fontVariantNumeric:'tabular-nums'}}>{monthlyEst()}</span>
                  </div>
                </div>
                <CrossSellRow title={`More from ${b.name}`} items={subRecos.data||[]} onAdd={openRecommendation} addLabel="View"/>
                {subscribeAction.error&&(
                  <div style={{padding:'10px 14px',background:C.errorBg,borderRadius:R.md,border:`1px solid ${C.error}`}}>
                    <p style={{fontSize:12,fontWeight:700,color:C.error}}>{humanizeError(subscribeAction.error)}</p>
                  </div>
                )}
                <Btn full disabled={subscribeAction.loading||(addresses.length>0&&!selAddr)} onClick={()=>subscribeAction.run()}>
                  {subscribeAction.loading?'Starting subscription…':`Pay ${fmt(initialCharge)} & start subscription`}
                </Btn>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};
